import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || 'Error desconocido' };
  }

  componentDidCatch(error, info) {
    // Log but never block render — friendly fallback below.
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info);
  }

  reset = () => this.setState({ hasError: false, message: '' });

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ minHeight: '100vh', padding: '40px 20px', background: 'var(--bg, #F9F8F6)', color: 'var(--text, #1A1A1A)' }}>
        <div style={{ maxWidth: 480, margin: '40px auto', background: 'var(--surface, #fff)', border: '1px solid var(--border, #E5E3DB)', borderRadius: 16, padding: 24 }}>
          <p style={{ fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase', fontWeight: 800, color: 'var(--text-muted, #6B6B66)', marginBottom: 8 }}>Ups</p>
          <h1 style={{ fontFamily: '"Cabinet Grotesk", sans-serif', fontSize: 28, fontWeight: 800, letterSpacing: '-0.02em', margin: '0 0 8px' }}>
            Algo salió mal
          </h1>
          <p style={{ color: 'var(--text-muted, #6B6B66)', fontSize: 13, marginBottom: 16 }}>
            Esto no debería pasar. Refresca la página para continuar.
          </p>
          {this.state.message && (
            <pre style={{ background: 'var(--surface-muted, #F3F1EC)', padding: 10, borderRadius: 8, fontSize: 11, overflow: 'auto', maxHeight: 120 }}>
              {this.state.message}
            </pre>
          )}
          <button
            onClick={() => { this.reset(); window.location.reload(); }}
            style={{ marginTop: 16, background: 'var(--primary, #C5533B)', color: '#fff', padding: '10px 18px', borderRadius: 10, border: 0, fontWeight: 800, fontSize: 13, cursor: 'pointer' }}
          >
            Refrescar
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
